var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 22.9766V35H0.554688V0.875H13.8672C16.4297 0.875 18.6797 1.34375 20.6172 2.28125C22.5703 3.21875 24.0703 4.55469 25.1172 6.28906C26.1641 8.00781 26.6875 9.96875 26.6875 12.1719C26.6875 15.5156 25.5391 18.1562 23.2422 20.0938C20.9609 22.0156 17.7969 22.9766 13.75 22.9766H7.58594ZM7.58594 17.2812H13.8672C15.7266 17.2812 17.1406 16.8438 18.1094 15.9688C19.0938 15.0938 19.5859 13.8438 19.5859 12.2188C19.5859 10.5469 19.0938 9.19531 18.1094 8.16406C17.125 7.13281 15.7656 6.60156 14.0312 6.57031H7.58594V17.2812Z",
    fill: "url(#paint0_linear_6_82)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_82",
    x1: 13.6211,
    y1: 0.875,
    x2: 13.6211,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/P.e4ff4501fd139939c02c01963fc81ddd.svg";
export { ForwardRef as ReactComponent };